module.exports = __webpack_public_path__ + "img/bongabong-elib.6d3e2904.jpg";